export default __webpack_public_path__ + "media/images/svg/dog-tag-bone-7eae946cedab7f7a48aa538706ef3d87.svg";